<template>
    <div class="modal modal-xl fade" id="opening-finished-modal" tabindex="-1" aria-labelledby="#opening-finished-modal-label" aria-hidden="true">
        <div class="modal-dialog" v-if="lastPulledCards && lastPulledCards.length > 0">
            <div class="modal-content">
                <div class="modal-header justify-content-between">
                    <h1 class="modal-title fs-5" id="opening-finished-modal-label">
                        {{ $t('boosters.pulledCards') }}

                        <small class="muted ms-4">
                            {{ lastPulledWorth }} <img src="/assets/dipocaco/currency_x64.png" alt="worth-sum" class="d-inline-block" style="max-height: 1.25em">
                        </small>
                    </h1>
                    <button type="button" class="btn-close text-reset" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body row">
                    <div class="card-wrapper">
                        <div class="pulled-cards-card-display" v-for="card in lastPulledCards">
                            <img :src="getCardImageUrl(card)" alt="" v-on:click="showCardDetails(card)" class="pulled-card-image"><br/>
                            <div class="new-card-marker">
                                <img src="/assets/dipocaco/icons/new.webp" alt="" v-if="card.hasOwnProperty('is_in_set_collection') && !card.is_in_set_collection === false"><br/>
                            </div>
                            <div class="pulled-card-info">
                                <h5 class="card-title w-100 mt-1 mb-1 fw-bold">{{ card.name }}</h5>
                                <img src="/assets/dipocaco/currency_x64.png" alt="" class="credit-icon"> {{ getPrice(card) }} |
                                <img :src="getRarityIcon(card)" class="rarity" alt="rarity-icon"> {{ card.rarity }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer row">
                    <div class="col-6 mx-0">
                        <button type="button" class="btn btn-secondary w-100" v-on:click="postPulledBooster">
                            <i class="fa-solid fa-share"></i> {{ $t('boosters.share') }}
                        </button>
                    </div>
                    <div class="col-6 mx-0">
                        <button type="button" class="btn btn-dark w-100" data-bs-dismiss="modal">{{ $t('boosters.close') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <card-detail-view-canvas :card="activeCard" :gallery="true"></card-detail-view-canvas>
</template>

<script>
import CardDetailViewCanvas from "./CardDetailViewCanvas.vue"
import CardService from "../../CardService";

export default {
    name: 'PulledCardsModal',
    computed: {
        CardService() {
            return CardService
        }
    },
    components: {CardDetailViewCanvas},
    props: {
        lastPulledCards: {},
        lastPulledWorth: {},
    },
    data() {
        return {
            activeCard: null
        }
    },
    methods: {
        showCardDetails(card) {
            this.activeCard = card;

            setTimeout(() => {
                $("#card-detail-view-canvas").offcanvas('toggle');
            }, 150)
        },
        postPulledBooster() {
            axios.post('/api/social/post-pull', {
                boosterCount: this.lastPulledBoosterCount
            }).then((response) => {
                iziToast.success({title: this.i18n.t('boosters.postedBooster')});

                setTimeout(() => {
                    $("#opening-finished-modal").modal('toggle');
                }, 100)
            })
        },
        getCardImageUrl(card) {
            return CardService.getCardImageUrl(card);
        },
        getRarityIcon(card) {
            return CardService.getRarityIcon(card);
        },
        getPrice(card) {
            return CardService.getPrice(card);
        },
    }
}
</script>

<style scoped lang="scss">
.card-wrapper {
    max-width: 100%;
    height: 60vh;
    max-height: 50em;
    display: flex;
    overflow-y: auto;
    align-content: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: stretch;

    .pulled-cards-card-display {
        display: inline-block;
        height: 100%;

        &:not(:last-child) {
            margin-right: 1em;
        }

        img {
            height: 85%;
            width: auto;
        }

        .card-title {
            text-align: center;
        }

        .rarity, .credit-icon {
            max-height: 1.25em;
            display: inline-block;
            margin-right: 0.15em;
            margin-top: -0.35em;
        }

        @keyframes wiggle {
            0% { transform: rotate(0deg); }
            25% { transform: rotate(-5deg); }
            50% { transform: rotate(5deg); }
            75% { transform: rotate(-5deg); }
            100% { transform: rotate(0deg); }
        }

        .new-card-marker {
            height: 4em !important;
            margin-top: -4em;
            float: right;
            position: relative;
            margin-right: 0.5em;
            filter: drop-shadow(2px 4px 6px black);

            img {
                max-height: 100%;
                animation: wiggle 0.5s infinite ease-in-out;
            }
        }
    }

    .pulled-card-image {
        border-radius: 5%;
    }
}
</style>